'use client';

import { useState, KeyboardEvent, useEffect } from 'react';
import { useInternalNotesContext } from 'src/shared/components/internal-notes/InternalNotesContext';
import { Button } from 'src/shared/components/ui/buttons/button';
import SaveButton from 'src/shared/components/ui/buttons/save-button';

export default function NoteCompose() {
  const { createMutation, isComposing, setIsComposing } = useInternalNotesContext();
  const [content, setContent] = useState('');

  useEffect(() => {
    if (!isComposing) {
      setContent('');
    }
  }, [isComposing]);

  if (!isComposing) return null;

  const handleCreate = () => {
    const trimmed = content.trim();
    if (!trimmed) return;
    createMutation.mutate(trimmed, {
      onSuccess: () => {
        setContent('');
        setIsComposing(false);
      },
    });
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleCreate();
    }
    if (event.key === 'Escape') {
      setContent('');
      setIsComposing(false);
    }
  };

  return (
    <div className="bg-white border border-border rounded-[3px] p-3">
      <textarea
        value={content}
        onChange={(event) => setContent(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Write a note..."
        className="w-full text-sm text-typography-black leading-5 resize-none focus:outline-none placeholder:text-typography-grey"
        rows={3}
        autoFocus
        disabled={createMutation.isPending}
      />
      <div className="flex items-center justify-end gap-2 mt-2">
        <Button
          variant="ghost"
          onClick={() => {
            setContent('');
            setIsComposing(false);
          }}
        >
          Cancel
        </Button>
        <SaveButton onClick={handleCreate} disabled={!content.trim()} loading={createMutation.isPending}>
          Save
        </SaveButton>
      </div>
    </div>
  );
}
